import styled, { createGlobalStyle } from 'styled-components'

export const Container = styled.div`
  .tox-tinymce {
    border: none !important;
    border-radius: var(--radius-brand) !important;
  }

  .tox-editor-header {
    padding: 0 !important;
    box-shadow: none !important;

    z-index: initial !important;
  }

  .tox-toolbar {
    padding: var(--space-100) !important;
    background-image: none !important;

    gap: var(--space-100) !important;
  }

  .tox-toolbar__group {
    padding: 0 !important;

    flex: 1 !important;
    gap: var(--space-100) !important;
  }

  .tox-toolbar__group:nth-child(2) {
    margin-left: auto !important;
  }

  .tox-tbtn {
    width: var(--space-800) !important;
    height: var(--space-800) !important;
    margin: 0 !important;
    border-radius: 0 !important;

    cursor: pointer !important;
  }

  .tox-tbtn--bespoke,
  .tox-tbtn--bespoke:hover,
  .tox-tbtn--bespoke:focus {
    background: var(--bg-secondary) !important;
  }

  .tox-tbtn--select {
    width: auto !important;
  }

  .tox-tbtn svg {
    fill: var(--text-primary) !important;
  }

  .tox-tbtn--disabled svg {
    opacity: 0.4 !important;
  }

  .tox-tbtn:hover,
  .tox-tbtn:focus {
    background: var(--bg-secondary) !important;
  }

  .tox-tbtn--enabled,
  .tox-tbtn--enabled:hover,
  .tox-tbtn--enabled:focus {
    background: var(--bg-tertiary) !important;
  }

  .tox-tbtn[aria-label='Source code'],
  .tox-tbtn[aria-label='Fullscreen'] {
    margin-left: auto !important;
  }

  .tox-tbtn[aria-label='Source code'] + .tox-tbtn[aria-label='Fullscreen'] {
    margin-left: 0 !important;
  }

  /* disabled */
  .tox-tinymce--disabled .tox-toolbar,
  .tox-tinymce--disabled iframe {
    background: var(--bg-secondary) !important;
  }

  .tox-tinymce--disabled .tox-tbtn {
    cursor: not-allowed !important;
  }

  .tox .tox-statusbar {
    background-color: var(--bg-primary) !important;
    color: var(--text-primary) !important;
    border-top: none;
  }

  .tox .tox-statusbar__resize-handle svg {
    fill: var(--text-primary) !important;
  }

  .tox .tox-toolbar {
    background-color: var(--bg-primary) !important;
  }

  .tox .tox-edit-area__iframe {
    background-color: var(--bg-primary) !important;
  }
`

export const DarkModeGlobalStyle = createGlobalStyle`
  .tox-dialog-wrap__backdrop {
    background-color: rgba(0, 0, 0, 0.8) !important;
  }

  .tox .tox-dialog {
    background-color: var(--bg-secondary) !important;
  }

  .tox .tox-dialog__header {
    background-color: var(--bg-secondary) !important;
    color: var(--text-primary) !important;
  }

  .tox .tox-dialog__footer {
    background-color: var(--bg-secondary) !important;
  }

  .tox-label {
    color: white !important;
  }

  .tox-dialog input {
    background-color: var(--bg-secondary) !important;
    color: white !important;
    border-color: var(--border-secondary) !important;
  }

  .tox .tox-button--naked {
    color: var(--text-primary) !important;
  }

  .tox .tox-listbox__select-chevron svg {
    fill: var(--text-primary) !important;
  }

  .tox :not(svg):not(rect) {
    color: var(--text-primary) !important;
  }

  .tox .tox-textfield:focus {
    box-shadow: none !important;
    border-color: var(--text-primary) !important;
  }

  .tox .tox-listboxfield .tox-listbox--select, .tox .tox-textarea, .tox .tox-textarea-wrap .tox-textarea:focus, .tox .tox-textfield, .tox .tox-toolbar-textfield {
    background-color: var(--bg-secondary) !important;
    color: white !important;
    border-color: var(--border-secondary) !important;
  }

  .tox .tox-listboxfield .tox-listbox--select:focus {
    box-shadow: none !important;
    border-color: var(--text-primary) !important;
  }

  .tox .tox-menu {
    background-color: var(--bg-secondary) !important;
  }

  .tox .tox-collection--list .tox-collection__item--active {
    background-color: var(--bg-secondary) !important;
  }

  .tox .tox-collection--list .tox-collection__item--enabled {
    background-color: var(--border-secondary) !important;
  }

  .tox .tox-button--secondary {
    color: var(--bg-secondary) !important;
  }
`
